<template>
    <div class="Paging">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next, jumper"
          next-text='下一页 >'
          :total="totalPage"
          :page-size='pageSize'
          :current-page="CurrentPage">
        </el-pagination>

        <span class="SureBtn">确定</span>
    </div>
</template>

<script>
export default {
  name: 'Paging',
  props: {
    totalPage: Number,
    pageSize: Number,
    CurrentPage: Number
  },
  components: {

  },
  data () {
    return {
    }
  },
  computed: {

  },
  created () {
  },
  mounted () {

  },
  methods: {
    // 分页功能
    handleCurrentChange (page) {
      this.$emit('curentPage', page)
    }
  }
}
</script>

<style scoped lang="less">
.Paging{
    margin: 50px auto 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    .SureBtn{
        display: inline-block;
        width: 80px;
        height: 36px;
        line-height: 36px;
        background: #F0F2F5;
        border-radius: 3px;
        border: 1px solid #D7DBE0;
        text-align: center;
        font-size: 14px;
    }
}
/deep/.number,
/deep/.btn-prev,
/deep/.more{
    width: 36px;
    height: 36px;
    line-height: 36px;
}
/deep/.btn-next{
    width: 80px;
    height: 36px;
}
/deep/.active{
    background-color: #3056D9 !important;
}
/deep/.is-in-pagination{
    width: 63px;
    margin: 0 5px;
}
/deep/.el-input__inner{
    height: 36px !important;
}
</style>
